export const TEST_VALUE_TEXT = 'Sample Text';
export const TEST_VALUE_DATE = '01.01.2001';
export const TEST_VALUE_TIME = '01:01';
